import React, { useEffect, useState } from "react";
import { useTable, useFilters, useGlobalFilter } from "react-table";
import { useNavigate } from "react-router";
import { Row, Col, Card } from "react-bootstrap";
import BTable from "react-bootstrap/Table";

import { Common, editMarks, MarkingLevels } from "../../helper";

import "../../assets/stlyes/marking.scss"
import "bootstrap/dist/css/bootstrap.min.css";

import EditSvg from "../../assets/images/Edit.svg";
import KeyIcon from "../../assets/images/keyIcon.svg";
import BlueCommentIcon from "../../assets/images/CommentBlueGD.png";
import GreenCommentIcon from "../../assets/images/CommentGreenEX.png";
import YellowCommentIcon from "../../assets/images/CommentYellowWT.png";
import RedCommentIcon from "../../assets/images/CommentRedBL.png";
import { Tooltip } from "@mui/material";

const styles = {
  sChip: {
    backgroundColor: "#e0e0e0",
    color: "#011C25",
    borderRadius: "16px",
    width: "28px",
    height: "24px",
    marginRight: "10px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  ealChip: {
    backgroundColor: "#e0e0e0",
    color: "#011C25",
    borderRadius: "16px",
    width: "44px",
    height: "24px",
    marginRight: "10px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  editButton: {
    width: "100px",
    height: "54px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
  },
  markButton: {
    backgroundColor: "#084059",
    boredrColor: "#084059",
    borderRadius: "100px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingRight: "17px",
    paddingTop: "5px",
    paddingBottom: "5px",
    color: "#FFFFFF",
  },
  flexCenter: { display: "flex", justifyContent: "center", alignItems: "center" },
  actualPredicted: {
    backgroundColor: "#E0E0E0",
    color: "#011C25",
    width: "80px",
    height: "30px",
    borderRadius: "100px",
    display: "flex",
    alignItems: "center",
    paddingTop: "5px",
    paddingBottom: "5px",
  },
  actualPredictedFont: { color: "#011C25" },
  chipbgColor: ["#F34970", "#F4C900", "#AABB5D", "#26C8B9", "#E0E0E0", "#26C8B9"],
  chips: {
    backgroundColor: "#e0e0e0",
    width: "50px",
    height: "32px",
    borderRadius: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent : "center",
    marginLeft: "30%",
    marginTop: "5%",
  },
  tableStyle: {
    background: "var(--table-backgound-color)", marginTop: "-20px", borderRadius: "0px 15px 15px 15px", border: "1px solid rgba(0, 0, 0, 0.23)"
  }
};

const mergedStyles = (j) => {
  let k = j.charAt(j.length - 1);
  return { ...styles.chips, backgroundColor: k === "A" ? "var(--absent-colour)" : k === "B" ? "var(--below-colour)" : k === "W" ? "var(--emerging-colour)" : k === "E" ? "var(--expected-colour)" : k === "G" ? "var(--greater-colour)" : "", color: k === "B" ? "var(--white-color)" : "" };
};

const getClassnameForMarks = () => { return "good" }

const DefaultColumnFilter = ({ column: { preFilteredRows } }) => {
  preFilteredRows.length;
  return ""
}

const Table = (props) => {
  const { columns, data } = props;
  const filterTypes = React.useMemo(
    () => ({
      text: (rows, id, filterValue) => {
        return rows.filter((row) => {
          const rowValue = row.values[id];
          return rowValue !== undefined ? String(rowValue).toLowerCase().startsWith(String(filterValue).toLowerCase()) : true;
        });
      }
    }), []);

  const defaultColumn = React.useMemo(() => ({ Filter: DefaultColumnFilter }), []);
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data, defaultColumn, filterTypes }, useFilters, useGlobalFilter);
  const firstPageRows = rows;

  return (
    <>
      <BTable striped bordered hover responsive {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, columnIndex) => (
                <th key={columnIndex} style={{ width: "110px", backgroundColor: columnIndex === 0 ? "#FAFAFA" : "inherit" }} {...column.getHeaderProps()} >
                  <div id="mark-header-container" className="marking-header-style">
                    {((column.columns !== undefined && column.columns[0].isKPI === true)) && <span className="keyIcon">{<img className="keyIcon" src={KeyIcon} alt="" />}</span>}
                    <span className="marking-header-headingtext"> {column.render("Header")}</span>
                  </div>
                  <div>{column.canFilter ? column.render("Filter") : null}</div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {firstPageRows.map((row, i) => {
            prepareRow(row);
            return (
              <tr key={i} {...row.getRowProps()}>{row.cells.map((cell, cellIndex) => { return <td key={cellIndex} style={{ backgroundColor: cellIndex === 0 ? "#FAFAFA" : "inherit" }} {...cell.getCellProps()}>{cell.render("Cell")}</td>; })}</tr>
            );
          })}
        </tbody>
      </BTable>
    </>
  );
}

const filterGreaterThan = (rows, id, filterValue) => {
  return rows.filter((row) => {
    const rowValue = row.values[id];
    return rowValue >= filterValue;
  });
}

filterGreaterThan.autoRemove = (val) => typeof val !== "number";

const MarkingTable = (props) => {
  const { headersData, tableBodyData, categoryName, subjectName, _subjectClassId, _classId, year } = props;
  const navigate = useNavigate();
  const [studentData, setStudentData] = useState([]);

  const SliderColumnFilter = (categoryName, subjectName, _subjectClassId, _classId, year, _description, identifier) => {
    return (
      <div className="d-flex align-items-center markButton">
        <button style={styles.markButton} className="topics-mark-button" onClick={() => navigate(editMarks(categoryName, subjectName, _subjectClassId, _classId, year, encodeURIComponent(_description), identifier))}>
          <img src={EditSvg} alt="vol" style={{ marginRight: "2px", marginLeft: "5px", height: "21px" }} />
          {Common.MARK}
        </button>
      </div>
    );
  }

  const columns = React.useMemo(() =>
    headersData?.map((ele, i) => {
      return (
        (i === 0) ? {
          Header: ele.description,
          columns: [{ Header: " ", accessor: ele.description, isKPI: false }]
        } : (i === headersData.length - 1) ?
          {
            Header: ele.description,
            columns: [{ Header: ele.actual === "Actual" ? "Current" : ele.actual, accessor: ele.actual, isKPI: false }, { Header: ele.predicted, accessor: ele.predicted, isKPI: false }]
          } :
          {
            Header: ele.description,
            columns: [{ Header: " ", accessor: ele.description === ele.description ? `${ele.description}` : ele.description, isKPI: ele.isKPI, Filter: SliderColumnFilter(categoryName, subjectName, _subjectClassId, _classId, year, ele.description, ele.identifier), filter: "equals" }]
          }
      )
    }), [headersData])

  const getstudentData = () => {
    const setComment = (mark) => {
      switch (mark) {
      case MarkingLevels.Bel:
        return RedCommentIcon;
      case MarkingLevels.Eme:
        return YellowCommentIcon;
      case MarkingLevels.Exp:
        return GreenCommentIcon;
      case MarkingLevels.GrD:
        return BlueCommentIcon;
      default:
        return null
      }
    }
  
    const arrayData = [];
    for (let i = 0; i < tableBodyData?.length; i++) {
      if (i === 0) {
        tableBodyData[i][" "] =
          <span >
            <div><span className="classAverage-text">Class Average</span></div>
            <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}></div>
          </span>
        tableBodyData[i]["Actual"] = <small className={getClassnameForMarks()}><p >{`${Math.round(tableBodyData[i].actual)}%`}</p></small>
        tableBodyData[i]["Predicted"] = <small className={getClassnameForMarks()}><p >{`${Math.round(tableBodyData[i].predicted)}%`}</p></small>
        for (let j = 0; j < tableBodyData[i].description.length; j++) {
          tableBodyData[i][tableBodyData[i].description[j].name] = tableBodyData[i].description[j].average ? <span className="chips" style={mergedStyles(tableBodyData[i].description[j].average)}>
            {
              tableBodyData[i].description[j].average[1] === "B" ? tableBodyData[i].description[j].average : ""
            }
          </span> : <span style={mergedStyles("0")}></span>
        }
        arrayData.push(tableBodyData[i]);
      }
      else {
        tableBodyData[i][" "] =
          <span >
            <div><small>{`${tableBodyData[i].firstName} ${tableBodyData[i].lastName}`} </small></div>
            <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
              {Object.entries(tableBodyData[i].otherNeeds).map(([key, value], index) => {
                if (value === true) {
                  return (
                    <div className="senStatus" key={index}>
                      <div className="dot" style={{ background: key === "pupilPremium" ? "#6D47FF" : "" || key === "eal" ? "#F4C900" : "" || (key === "ehcp" || key === "senStatus") ? "#F50057" : "" }}></div>
                      <span className="nameText">{key === "pupilPremium" ? "PP" : "" || key === "senStatus" ? "SEND" : "" || key === "ehcp" ? "EHCP" : "" || key === "eal" ? "EAL" : ""}</span>
                    </div>
                  )
                }
              })}
            </div>
          </span>
        tableBodyData[i]["Actual"] = <small className={getClassnameForMarks()}><p >{`${Math.round(tableBodyData[i].category[0].actual)}%`}</p></small>
        tableBodyData[i]["Predicted"] = <small className={getClassnameForMarks()}><p >{`${Math.round(tableBodyData[i].category[0].predicted)}%`}</p></small>
        for (let j = 0; j < tableBodyData[i].category[0].description.length; j++) {
          let _markings = tableBodyData[i].category[0].description[j].markings
          let _commemts = tableBodyData[i].category[0].description[j].comment
          tableBodyData[i][tableBodyData[i].category[0].description[j].name] = tableBodyData[i].category[0].description[j].markings[0] ? <span className="chips" style={
            mergedStyles(_markings[0])
          }>
            {
              _markings.length > 1 ? _markings[1] : _markings[0][1] === "B" ? _markings[0] : ""
            }{_commemts && _commemts && <Tooltip title={_commemts} arrow followCursor ><img src={setComment(_markings[0][1])} alt="" style={{ left: _markings[0][1] !== "B" ? "24px" : "12px" }} className="marking-table-comment" /></Tooltip>}
          </span> : <span style={mergedStyles("0")}></span>
          
        }
        arrayData.push(tableBodyData[i]);
      }
    }
    setStudentData(arrayData);
  }
  useEffect(() => {
    getstudentData();
  }, [tableBodyData])
  
  return (
    <Row>
      <Col sm={12} style={styles.tableStyle}>
        <Card style={{ background: "#FAFAFA" }}>
          <Table responsive columns={columns && columns} data={studentData} />
        </Card>
      </Col>
    </Row>
  );
}

export { MarkingTable };
